import { FormikProps } from 'formik';
import { Upload } from 'lucide-react';
import { MatchEventType } from 'shared/types/match-event';
import { Values } from 'modules/template-editor/domain/interface/form/board';
import { Trans, useLingui } from '@lingui/react/macro';
import { useCallback } from 'react';
import { toast } from 'react-toastify';
import UDButton from 'ud-ui/components/button';
import UDText from 'ud-ui/components/text';
import { getEventsOptions, getTypeOptions } from '../events-selector/type';

interface IProps {
  formProps: FormikProps<Values>;
}

function ImportButton(props: IProps) {
  const { t } = useLingui();
  const { formProps } = props;

  const importBoard = useCallback(
    (formProps: FormikProps<Values>) => {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.board';
      input.style.display = 'none';
      document.body.appendChild(input);
      input.onchange = () => {
        const reader = new FileReader();
        reader.onload = function (e) {
          if (e === null) return;
          if (e.target === null) return;
          const src = e.target.result;
          if (typeof src === 'string') {
            const board = JSON.parse(
              decodeURIComponent(
                window
                  .atob(src.split('data:application/octet-stream;base64,')[1])
                  .split('')
                  .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                  })
                  .join(''),
              ),
            );

            const newValues = { ...formProps.values };
            if (board?.name) newValues.name = board.name;
            if (board?.type) newValues.type = getTypeOptions().find((o) => o.value === board.type);
            if (board?.objects) newValues.objects = board.objects;
            if (board?.version) newValues.version = board.version;
            switch (board?.type) {
              case 'events': {
                if (board?.duration) newValues.duration = board.duration;
                if (board?.events) newValues.events = getEvents(board.events);
                break;
              }
              case 'carousel': {
                if (board?.duration) newValues.duration = board.duration;
                break;
              }
            }

            formProps.setValues(newValues);
            formProps.setFieldTouched('name', true, false);
            toast.success(t`Данные успешно импортированы`);
          }
        };

        if (input.files) {
          reader.readAsDataURL(input.files[0]);
        }
      };

      input.click();
    },
    [t],
  );

  return (
    // Импорт локальный (файл → значения формы), запроса нет; гаснет, пока форма сохраняется.
    <UDButton
      onClick={() => {
        importBoard(formProps);
      }}
      type="button"
      variant="secondary"
      style={{ height: 36, paddingInline: 14 }}
      className="flex-center"
      disabled={formProps.isSubmitting}
    >
      <Upload size={20} style={{ marginRight: '10px' }} />
      <UDText type={'subhead'}>
        <Trans>Импортировать файл</Trans>
      </UDText>
    </UDButton>
  );
}

export default ImportButton;

function getEvents(events: MatchEventType[]) {
  return getEventsOptions().filter((option) => events.includes(option.value));
}
